import React, { useState } from 'react'
import { useDraggable } from '@dnd-kit/core'
import { StackedImage } from './StackedImage'
import './DraggableCard.scss'

export const DraggableCard = ({
  card,
  wasUsed,
  isInBottomList = false,
  style,
  gameType,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const { attributes, listeners, setNodeRef } = useDraggable({
    disabled: wasUsed && isInBottomList, // Disable dragging only for bottom list after drop
    id: card.id,
  })

  return (
    <div
      ref={el => {
        setNodeRef(el)
      }}
      {...listeners}
      {...attributes}
      style={{
        cursor: wasUsed && isInBottomList ? 'unset' : 'grab',
        touchAction: 'none',
        msTouchAction: 'none',
        ...style,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <StackedImage
        style={{
          opacity: wasUsed && isInBottomList ? 0.2 : 1, // Fade out in the bottom list
        }}
        className={`draggable-card ${isInBottomList ? 'bottom-list' : ''}`}
        image={card}
        isDropped={wasUsed && !isInBottomList}
        gameType={gameType}
      />
    </div>
  )
}
